import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { setLenis } from "@/lib/scroll";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Maker from "@/components/landing/Maker";
import VideoShowcase from "@/components/landing/VideoShowcase";
import Chapters from "@/components/landing/Chapters";
import Stats from "@/components/landing/Stats";
import Faq from "@/components/landing/Faq";
import Pricing from "@/components/landing/Pricing";
import Footer from "@/components/landing/Footer";
import Privacy from "@/components/landing/Privacy";
import CookieBanner from "@/components/landing/CookieBanner";
import BackToTop from "@/components/landing/BackToTop";
import Admin from "@/pages/Admin";
import ClubFin from "@/pages/ClubFin";
import Community from "@/pages/Community";
import Campaign from "@/pages/Campaign";

const Landing = () => {
    // Telt 1 paginabezoek per sessie (zichtbaar in /statistieken Proef-tab); mag nooit blokkeren
    useEffect(() => {
        if (sessionStorage.getItem("cf-pv")) return;
        sessionStorage.setItem("cf-pv", "1");
        try {
            fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/pageview`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ path: "/" }),
                keepalive: true,
            }).catch(() => {});
        } catch { /* negeren */ }
    }, []);

    return (
    <>
        <Nav />
        <main>
            <Hero />
            <Marquee />
            <VideoShowcase />
            <Chapters />
            <Stats />
            <Faq />
            <Maker />
            <Pricing />
        </main>
        <Footer />
    </>
    );
};

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09 });
        setLenis(lenis);
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <div className="App" data-testid="app-root">
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/cookies" element={<Navigate to="/privacy" replace />} />
                    <Route path="/community" element={<Community />} />
                    <Route path="/club-fin" element={<ClubFin />} />
                    <Route path="/contact" element={<Navigate to="/community" replace />} />
                    <Route path="/statistieken" element={<Admin />} />
                    <Route path="/admin" element={<Navigate to="/statistieken" replace />} />
                    <Route path="/c/:slug" element={<Campaign />} />
                </Routes>
            </BrowserRouter>
            <CookieBanner />
            <BackToTop />
            <Toaster position="bottom-right" richColors />
        </div>
    );
}

export default App;
